import React from "react";

const Contact = () => {
  return <h1>This is Contact Us Page!!!!</h1>;
};

export default Contact;
